import * as ActionTypes from '../actions/user'
import { setContext } from '$utils/log'

import userModel from '$models/user'

const intialState = {
  user: {},
  loadedUser: {},
  isLoading: false,
  isLoadingChannels: false,
  isLoadingUser: false,
  isAuthenticated: false,
  isReachable: false,
  isBanned: false,
  channels: [],
  meta: null
}

const user = (state = intialState, action) => {
  switch (action.type) {
    case ActionTypes.LOAD_USER_REQUEST: {
      return {
        ...state,
        isLoading: true
      }
    }

    case ActionTypes.LOAD_USER_SUCCESS: {
      const user = userModel(action.response) || {}

      setContext({
        user
      })

      return {
        ...state,
        ...user,
        isLoading: false,
        isAuthenticated: true
      }
    }

    case ActionTypes.LOAD_USER_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false
      }
    }

    case ActionTypes.UPDATE_USER_SUCCESS: {
      const data = action.data || {}

      return {
        ...state,
        ...data
      }
    }

    case ActionTypes.GET_USER_FAILURE: {
      return {
        ...state,
        isReachable: false,
        isLoadingUser: false
      }
    }

    case ActionTypes.GET_USER_REQUEST: {
      return {
        ...state,
        isLoadingUser: true,
        isReachable: false
      }
    }

    case ActionTypes.GET_USER_SUCCESS: {
      return {
        ...state,
        loadedUser: userModel(action.response),
        isReachable: true,
        isLoadingUser: false
      }
    }

    case ActionTypes.GET_USER_CHANNELS_REQUEST: {
      return {
        ...state,
        isLoadingChannels: true
      }
    }

    case ActionTypes.GET_USER_CHANNELS_SUCCESS: {
      const channels = state.channels ? [...state.channels, ...action.response.channels] : action.response.channels
      const meta = action.response.meta

      return {
        ...state,
        channels,
        meta,
        isLoadingChannels: false
      }
    }

    case ActionTypes.UPDATE_USER_BAN_REQUEST: {
      return {
        ...state
      }
    }

    case ActionTypes.UPDATE_USER_BAN_SUCCESS: {
      return {
        ...state,
        isBanned: true
      }
    }

    case ActionTypes.UPDATE_USER_BAN_FAILURE: {
      return {
        ...state,
        isBanned: false
      }
    }

    default:
      return state
  }
}

export default user
